"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_API_URL = 'https://bugzilla.mozilla.org';
exports.DEFAULT_API_EXTENTION = '/rest';
exports.DEFAULT_CONFIG = {
    url: exports.DEFAULT_API_URL,
    api_extention: exports.DEFAULT_API_EXTENTION
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/defaults.js
// module id = 418
// module chunks = 0